module.exports = __webpack_public_path__ + "img/slide2.deb9de0d.jpg";